import { EndExamModal } from 'Components/modal/EndExamModal/EndExamModal'
import { createReactElement, UpdatableReactElement } from 'shared/utils/react.utils'
import { BaseModalController, IModal, ModalContext } from '../Modal'
import { ExamContextHandler } from 'Core/ContextHandler/ExamContextHandler'
import { ContainerType } from 'Types/Tasks.types'

export type EndExamModalMetaData = unknown

export class EndExamModalController
    extends BaseModalController<EndExamModalMetaData>
    implements IModal
{
    static Id = 'end-exam-modal' as const
    constructor(modalContext: ModalContext) {
        super(modalContext, EndExamModalController.Id)
    }

    createElement(): UpdatableReactElement {
        return createReactElement(EndExamModal, {
            getVisibility: this.getVisibility.bind(this),
            content: 'Do you want to end the exam?',
            onConfirm: this.onClose.bind(this, 'submit'),
            onCancel: this.onClose.bind(this, 'dismiss'),
        })
    }

    private onClose(action: 'submit' | 'dismiss' = 'dismiss') {
        if (action === 'submit') {
            ;(
                this.modalContext.contextHandler as ExamContextHandler<ContainerType, unknown>
            ).endExam()
        }
        this.setVisibility(false)
    }
}
